export default __webpack_public_path__ + "48a04a631e988c4244976116453c30ac.svg";